import { InputContainer } from '@creditornot/cb-form';
import React from 'react';
import { Field, Form } from 'react-final-form';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import validateYupSchema from 'common/utils/validateYupSchema';
import WeeklyScheduleInput from 'modules/self-serve-sign-up/common/WeeklyScheduleInput/WeeklyScheduleInput';

import { OpeningHours, OpeningHoursValidationSchema } from './validation';

type OpeningHoursFormProps = {
  formId: string;
  weeklySchedule: OpeningHours;
  handleSubmit: (values: OpeningHours) => Promise<void | { [key: string]: string | Error }>;
};

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const OpeningHoursForm = ({ formId, handleSubmit, weeklySchedule }: OpeningHoursFormProps) => {
  const intl = useIntl();

  return (
    <Form<OpeningHours>
      initialValues={weeklySchedule}
      onSubmit={handleSubmit}
      validate={validateYupSchema(OpeningHoursValidationSchema)}
    >
      {({ handleSubmit }) => (
        <StyledForm onSubmit={handleSubmit} id={formId}>
          <InputContainer label={intl.formatMessage({ id: 'self-serve-sign-up.form-labels.venues.days-open' })}>
            <Field name="openingHours">
              {({ input }) => <WeeklyScheduleInput value={input.value} onChange={input.onChange} />}
            </Field>
          </InputContainer>
        </StyledForm>
      )}
    </Form>
  );
};

export default OpeningHoursForm;
